import React from 'react';
import { format } from 'date-fns';

import { BlogType } from '@utils/types/blog';
import ImageBackground from '@components/_shared/imageBackground';
import Button from '@components/_shared/button';
import { parseDateWithoutTimezone } from '@utils/dates';

import styles from './styles.module.scss';

type Props = {
  featuredBlog: BlogType;
};

const FeaturedBlog = (props: Props) => {
  const { featuredBlog } = props;
  return (
    <ImageBackground
      containerStyle={styles.featuredBlog}
      backgroundImageStyle={`
        linear-gradient(180deg, rgba(248, 244, 241, 0.33) 0%, rgba(248, 244, 241, 0.9) 52.79%, #F8F4F1 87.17%),
        url(${featuredBlog.image})
      `}
    >
      <div className={styles.featuredBlog__featured}>Featured</div>
      <h1>{featuredBlog.title}</h1>
      <div className={styles.featuredBlog__timeInfo}>
        <div className={styles.featuredBlog__publishedAt}>
          {format(
            parseDateWithoutTimezone(
              featuredBlog.publishedAt || featuredBlog._createdAt
            ),
            `MMM dd, yyyy`
          )}
        </div>
        <div className={styles.featuredBlog__readTime}>
          {`${featuredBlog.readTime} min read`}
        </div>
      </div>
      <Button
        containerStyle={styles.featuredBlog__buttonContainer}
        variant="blueContained"
        to={`/blog/${featuredBlog.slug?.current}`}
      >
        Read More
      </Button>
    </ImageBackground>
  );
};

export default FeaturedBlog;
